export default __webpack_public_path__ + "static/media/personalization.200c7b99.svg";